import { IDisplayOptions, INotesSection } from '@modeso/types__aumico-lib-annualreport-be';
import Debug from 'debug';
import { cloneDeep } from 'lodash-es';
import { EMPTY_ARRAY_LENGTH } from '../../../../../../aumico-lib-core-fe/src/lib';
import { NotesEmptyLinesRemovalHelper } from '../../../../../../aumico-lib-notes-fe/src/lib';

export const debug = Debug('aumico:annualreports:NotesComponentsHTMLUtil');

export class NotesComponentsHTMLUtil {
    constructor(
        private notesAccordions: INotesSection[],
        private printDisplayOptions: IDisplayOptions,
        private notesEmptyLinesRemovalHelper: NotesEmptyLinesRemovalHelper,
    ) {
        Object.assign(this, notesAccordions);
        Object.assign(this, printDisplayOptions);
    }

    public getNotesComponentsHTMLMap(activeLocale: string): Map<string, Map<string, string>> | undefined {
        const notesComponentsHTMLMap = new Map<string, Map<string, string>>();

        if (this.notesAccordions.length === EMPTY_ARRAY_LENGTH) {
            return undefined;
        }

        // Step 1: filter hidden components first (isHidden flag is lost by removeEmptyLinesOfNotes)
        let notesAccordions = cloneDeep<INotesSection[]>(this.notesAccordions)
            .filter((accordion) => accordion != null)
            .map((accordion) => ({
                ...accordion,
                data: accordion.data.filter((component) => component != null && !component.isHidden),
            }))
            .filter((accordion) => accordion.data.length !== EMPTY_ARRAY_LENGTH);

        // Step 2: then remove empty lines on the already-filtered data
        if (this.printDisplayOptions.hideEmptyLines || this.printDisplayOptions.notesHideEmptyLines) {
            notesAccordions = this.notesEmptyLinesRemovalHelper.removeEmptyLinesOfNotes(
                notesAccordions,
                activeLocale,
            );
        }

        notesAccordions.forEach((noteAccordion, accordionIndex: number) => {
            const componentHTMLMap = new Map<string, string>();
            noteAccordion.data.forEach((component, componentIndex: number) => {
                if (component.componentName === 'Super Table') {
                    const selector = '.accordion' + accordionIndex + '-' + 'component' + componentIndex;
                    const elements = document.querySelectorAll(selector);

                    const serializedHTML = Array.from(elements)
                        .map((el) => el.outerHTML)
                        .join('');

                    const cleanedHTML = serializedHTML
                        .replace(/<!--[\s\S]*?-->/g, '') // Remove comments
                        .replace(/\s_ngcontent-[a-z0-9-]+="[^"]*"/g, '') // Remove _ngcontent-* attributes
                        .replace(/\sng-[a-z0-9-]+="[^"]*"/g, ''); // Remove ng-* attributes

                    componentHTMLMap.set(`${component.componentId}_${componentIndex}`, cleanedHTML);
                    notesComponentsHTMLMap.set(accordionIndex.toString(), componentHTMLMap);
                }
            });
        });
        return notesComponentsHTMLMap;
    }
}
